import {
  MonitorRounded as MonitorRoundedIcon,
  HomeWorkRounded as HomeWorkRoundedIcon,
  BoltRounded as BoltRoundedIcon,
  LocalFireDepartmentRounded as LocalFireDepartmentRoundedIcon,
  WaterDropRounded as WaterDropRoundedIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

const useMenuItems = () => {
  const { t } = useTranslation([
    'portfolio-analysis',
    'portfolio-analysis_water',
    'portfolio-analysis_heat',
    'portfolio-analysis_power',
  ]);
  const menuItems = useMemo(() => {
    return [
      {
        label: t('app_bar.overview'),
        icon: <MonitorRoundedIcon />,
        path: '',
      },
      {
        label: t('app_bar.building'),
        icon: <HomeWorkRoundedIcon />,
        path: 'building',
      },
      {
        label: t('app_bar.power'),
        icon: <BoltRoundedIcon />,
        path: 'power/overview',
      },
      {
        label: t('app_bar.heat'),
        icon: <LocalFireDepartmentRoundedIcon />,
        path: 'heat/overview',
      },
      {
        label: t('app_bar.water'),
        icon: <WaterDropRoundedIcon />,
        path: 'water/overview',
      },
    ];
  }, [t]);
  return menuItems;
};

export default useMenuItems;
